import { http } from '../config/config-receituario'

function getHeaders(token, key, multipart) {
  const headers = {
    Authorization: token,
  }

  if (key) {
    headers.key = key
  }

  if (multipart) {
    headers['Content-Type'] = 'multipart/form-data'
  }

  return headers
}

function cleanParams(params = {}) {
  return Object.keys(params).reduce((query, key) => {
    const value = params[key]

    if (value !== undefined && value !== null && value !== '') {
      query[key] = value
    }

    return query
  }, {})
}

export default {
  listarPendentes(token, key, params = {}) {
    return http.get('webservices/agrodefesa', {
      headers: getHeaders(token, key),
      params: cleanParams(params),
    })
  },

  enviar(token, key, payload) {
    const formData = new FormData()

    if (payload.startDate) {
      formData.append('startDate', payload.startDate)
    }

    if (payload.endDate) {
      formData.append('endDate', payload.endDate)
    }

    if (payload.numeroReceita) {
      formData.append('numeroReceita', payload.numeroReceita)
    }

    formData.append('file', payload.file)

    return http.post('webservices/agrodefesa', formData, {
      headers: getHeaders(token, key, true),
    })
  },
}
